import { JsonProperty } from '../json-map.util';
import { DashboardLessonModel } from '../lesson/lesson.model';
import { StudentStatsLifetime, StudentStatsModel } from '../student/student-stats.model';
import { CourseModel } from '../course/course.model';


class DashboardModel {

  thisWeekProgress: number = undefined;

  @JsonProperty({ clazz: DashboardLessonModel })
  lessons: DashboardLessonModel[];

  @JsonProperty({ clazz: StudentStatsModel })
  lastLessonStats: StudentStatsModel = undefined;

  @JsonProperty({ clazz: StudentStatsModel })
  lifeTimeStats: StudentStatsLifetime = undefined;

  @JsonProperty({ clazz: CourseModel })
  course: CourseModel = undefined;

}

export { DashboardModel };


